import {
  comparableLoadsLaneToleranceRadii,
  comparableLoadsWindows,
} from '../admin/comparable-loads.ts'
import {
  vObject,
  vOpt,
  vOptional,
  type vOutput,
  vPicklist,
  vPipe,
  vStringToNumber,
} from '../validation/index.ts'

export const comparableLoadsLeadTimeFilters = [
  'any',
  'lt-7',
  'lt-14',
  'lt-30',
  'gt-30',
] as const

export type ComparableLoadsLeadTimeFilter =
  (typeof comparableLoadsLeadTimeFilters)[number]

export const getComparableLoadsLeadTimeFilterLabel = (
  filter: ComparableLoadsLeadTimeFilter,
) => {
  switch (filter) {
    case 'any':
      return 'Any lead time'
    case 'lt-7':
      return 'Less than 7 days'
    case 'lt-14':
      return 'Less than 14 days'
    case 'lt-30':
      return 'Less than 30 days'
    case 'gt-30':
      return 'More than 30 days'
  }
}

export const shipperComparableLoadsQuerySchema = vObject({
  bookedWindow: vOptional(vPicklist(comparableLoadsWindows), '30-days'),
  laneToleranceRadiusMiles: vOpt(
    vPipe(vStringToNumber(), vPicklist(comparableLoadsLaneToleranceRadii)),
    25,
  ),
  leadTimeFilter: vOptional(vPicklist(comparableLoadsLeadTimeFilters), 'any'),
})

export type ShipperComparableLoadsQuery = vOutput<
  typeof shipperComparableLoadsQuerySchema
>

export interface ShipperComparableLoadSource {
  costPerMile: number | null
  amount?: number | null
  distance?: number | null
}

export interface ShipperPriceBenchmark {
  count: number
  average: number | null
  costPerMileAverage: number | null
}

export interface ShipperMostRecentComparable {
  loadId: string
  carrierId: string
  carrierName: string
  amount: number | null
  costPerMile: number | null
  bookedDate: string | null
}

export interface ShipperComparableLoadsResult {
  source: ShipperComparableLoadSource
  account: ShipperPriceBenchmark
  mostRecent?: ShipperMostRecentComparable | null
}
